// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox___MzC2","checkboxText":"Checkbox_checkboxText__3mRR9","disabledCheckboxText":"Checkbox_disabledCheckboxText__38vuE"};